import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { ChangePassword, UserProfile } from 'types/api'
import { BaseParams } from 'types/utils'

export function useChangePassword() {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError() // Ensure useOnError is used

  const { t } = useTranslation('settings')

  async function changePassword({ body }: BaseParams<ChangePassword, 'POST'>) {
    const res = await apiClient.post<UserProfile>(
      SNA_PREFIX + `users/me/change-password`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: changePassword,

    onSuccess: () => {
      toast.success({ message: t('success.passwordChanged') })
      queryClient.invalidateQueries({ queryKey: ['profile'] })
    },
    onError
  })
}
